<template>
	<div class="list-layout-switcher">
		<div
			class="list-layout-switcher__item"
			:class="{ active: isActive(option.value) }"
			v-for="option in listLayoutOptions"
			:key="option.value"
			@click="setListLayout(option.value)"
		>
			<FontAwesomeIcon :icon="option.icon" />
		</div>
	</div>
</template>

<script setup lang="ts">
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { TitleListLayout } from '@/enums/title-list-layout';
import { useFilterStore } from '@/stores/pinia/useFilterStore';
import { faThList, faBars, faTh } from '@fortawesome/free-solid-svg-icons';

const router = useRouter();
const filterStore = useFilterStore();

function isActive(layout: TitleListLayout): boolean {
	const currentLayout = filterStore.currentFilters.list_layout || TitleListLayout.CARD;

	return currentLayout === layout;
}

async function setListLayout(layout: TitleListLayout): Promise<void> {
	const newRoute = filterStore.setFilterValue({
		filterName: 'list_layout',
		filterValue: layout,
	});

	TrackingHelper.trackEvent('userinteraction', {
		action: 'layout_toggled',
		label: layout,
	});

	if (newRoute) router.push(newRoute);
}

const listLayoutOptions = [
	{
		label: 'LIST',
		value: TitleListLayout.CARD,
		icon: faThList,
	},
	{
		label: 'ROW',
		value: TitleListLayout.ROW,
		icon: faBars,
	},
	{
		label: 'GRID',
		value: TitleListLayout.GRID,
		icon: faTh,
	},
];
</script>

<style lang="scss" scoped>
@import '~@/styles/variables.scss';

.list-layout-switcher {
	display: flex;
	align-items: center;
	justify-content: center;

	&__item {
		padding: 5px 10px;
		cursor: pointer;
		border-radius: $jw-border-radius;

		&.active {
			background-color: $jw-color-mediumblue--dark;
			color: $jw-color-white;
		}
	}
}
</style>
